import React, { useEffect } from 'react';
import { MagnifyingGlassIcon, ArrowPathIcon, IdentificationIcon, TrashIcon } from '@heroicons/react/24/outline';
import { Button, Select, Option } from '@material-tailwind/react';
import { useContextoGlobal } from '../../Context/contextoGlobal';

export const ButtonsIglesiasMinistros = ({ 
    registrosActivos, 
    setRegistrosActivos, 
    buscarDatos, 
    handleSearchData, 
    limpiarFiltros, 
    texto1, 
    texto2,
    mostrarBotonCredenciales,
    mostrarBotonRefrescar = true,
}) => {

    const contexto = useContextoGlobal();
    const credenciales = contexto ? contexto.credenciales : [];
    const mostrarCredenciales = contexto ? contexto.mostrarCredenciales : false;
    const setMostrarCredeciales = contexto ? contexto.setMostrarCredeciales : () => {};

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Enter') {
                event.preventDefault(); 
                handleSearchData();
            }
            if (event.key === 'Escape') {
                limpiarFiltros();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleSearchData, limpiarFiltros]); 

    const handleCredenciales = () => {
        setMostrarCredeciales(!mostrarCredenciales);
    };

    return (
        <div className="mt-4 flex w-full flex-col gap-3 md:items-end">
            <div className="w-full flex justify-center md:justify-end select-ui-data">
                <div className="w-full md:w-56 bg-white rounded-md">
                    <Select
                        label="Estado de los registros"
                        value={registrosActivos ? 'activos' : 'inactivos'}
                        onChange={(val) => setRegistrosActivos(val === 'activos')}
                        className="focus:!border-blue-500 focus:!border-t-transparent focus:!border-2"
                    >
                        <Option value="activos">{texto1}</Option>
                        <Option value="inactivos">{texto2}</Option>
                    </Select>
                </div>
            </div>

            <div className="flex flex-wrap items-center justify-center md:justify-end gap-3 select-ui-data">
                {mostrarBotonCredenciales && (
                    <Button
                        color="amber"
                        variant={mostrarCredenciales ? "filled" : "gradient"}
                        className="rounded-md flex items-center h-10 px-4"
                            title={(!credenciales || credenciales.length === 0) ? 'Abra el panel y luego seleccione ministros desde Acciones para incluirlos en credenciales' : 'Clic para ver las credenciales a imprimir'}
                        onClick={handleCredenciales}
                    >
                        <IdentificationIcon className="h-5 w-5 mr-2" />
                        CREDENCIALES IMPRESAS{credenciales && credenciales.length > 0 ? ' (' + credenciales.length + ')' : ''}
                    </Button>
                )}

                {mostrarBotonRefrescar && (
                    <Button
                        color="blue-gray"
                        variant="outlined"
                        className="rounded-md flex items-center h-10 px-4"
                        onClick={buscarDatos}
                    >
                        <ArrowPathIcon className="h-4 w-4 mr-2" /> REFRESCAR
                    </Button>
                )}

                <Button 
                    variant="text" 
                    className="text-red-400 bg-red-50 hover:bg-red-100 h-10 px-4 flex items-center" 
                    onClick={limpiarFiltros}
                    title="(Esc)"
                >
                    <TrashIcon className="h-4 w-4 mr-2" />
                    LIMPIAR FILTROS
                </Button>

                <Button
                    color="blue"
                    className="rounded-md flex items-center h-10 px-4"
                    onClick={handleSearchData}
                    title="(Enter)"
                >
                    <MagnifyingGlassIcon className="h-4 w-4 mr-2" /> BUSCAR
                </Button>
            </div>
        </div>
    );
};
